import { Tooltip as MuiTooltip, TooltipProps } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  toolTipBackground: {
    backgroundColor: '#2d2d2d',
  },
  arrow: {
    color: '#2d2d2d',
  },
});

export function Tooltip(props: TooltipProps) {
  const classes = useStyles();
  return (
    <MuiTooltip
      classes={{
        tooltip: classes.toolTipBackground,
        arrow: classes.arrow,
      }}
      {...props}
    />
  );
}
